export const environment = {
  production: false,
  // Host for the fixed-content videos and their .vtt caption tracks.
  // Captions used to be hardcoded in learn-more.component.ts, which meant
  // Production served them from the dev container.
  fixedContentBaseUrl: 'https://radian01.blob.core.windows.net/onemorningdev/fixedcontent/',
  homeVideoURL: 'https://radian01.blob.core.windows.net/onemorningdev/fixedcontent/one_morning_-_moments_of_realization.mp4',
  learnMoreVideoURL: 'https://radian01.blob.core.windows.net/onemorningdev/fixedcontent/one_morning_-_what\'s_an_eap.mp4'
};

